module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "moreNews",
    on: {
      "touchmove": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closePreview.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "moreNews-contentbox"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "moreNews-content-main"
  }, _vm._l((_vm.showData), function(item) {
    return _c('div', {
      staticClass: "news-item",
      on: {
        "click": function($event) {
          return _vm.toArticle(item.url)
        }
      }
    }, [_c('div', {
      staticClass: "triangle_border_right"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])])
  }), 0), _vm._v(" "), _c('img', {
    staticClass: "icon-close",
    attrs: {
      "src": require("../../assets/img/index/news-close.svg"),
      "alt": ""
    },
    on: {
      "click": _vm.closePreview
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "moreNews-content-head"
  }, [_c('span', [_vm._v("消息列表")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f3e1472","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/moreNews.vue
// module id = 247
// module chunks = 45